import { useRef } from 'react'

export const useLoadScript = (src: string, id: string): void => {
  const loaded = useRef(false)
  if (typeof window !== 'undefined' && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      const position = document.querySelector('head')
      if (!position) {
        return
      }
      const script = document.createElement('script')
      script.setAttribute('async', '')
      script.setAttribute('id', id)
      script.src = src
      position.appendChild(script)
    }

    loaded.current = true
  }
}
